import React from 'react';
import { agentStates } from '../../data/agentStates';
import { floorStates } from '../../utils/floor';
import { formatHhMm } from '../../utils/format';
import type { FloorDay, FloorStates } from '../../types/voip';
const heights = {
  xs: 'h-1',
  sm: 'h-1.5',
  md: 'h-3'
};
interface StateBarProps {
  day?: FloorDay;
  states?: FloorStates;
  size?: keyof typeof heights;
  className?: string;
}

/** Stacked floor-time bar: On Call, Ready, Waiting, Not Ready. Unrecorded login time shows as empty track. */
export function StateBar({
  day,
  states,
  size = 'sm',
  className = ''
}: StateBarProps) {
  const s = states ?? (day ? floorStates(day) : null);
  if (!s) return null;
  const total = s.loggedIn || 1;
  const summary = `On Call ${formatHhMm(s.onCall)}, Waiting ${formatHhMm(s.waiting)}, Ready ${formatHhMm(s.ready)}, Not Ready ${formatHhMm(s.notReady)}`;
  return <div role="img" aria-label={`Logged in ${formatHhMm(s.loggedIn)}: ${summary}`} className={`flex w-full overflow-hidden rounded-full bg-canvas ${heights[size]} ${className}`} data-id="element-173" data-mp="3990z42i8frw9">
      {agentStates.map(st => <span key={st.key} className={`h-full ${st.className}`} style={{
      width: `${s[st.key] / total * 100}%`
    }} data-id="element-174" data-mp="1dmj7mba5tv9x" />)}
    </div>;
}